import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-olo';

const validator = () => null;

const vFParams = {
  paragraph: 'Based on information received from Other Licensed Operators, please select the relevant type of Post Change communications.',
};

const paragraphOLO = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphOLO };
